"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
class DeferredPromiseExecutor {
    //region Constructor
    constructor(timeout = 10800 * 1000 /*3 hours*/, enableLogging = false) {
        //endregion
        //region Private Fields
        this.instanceId = DeferredPromiseExecutor.generateRandomId();
        this.deferredPromises = {};
        this.enableLogging = false;
        this.defer = (id) => {
            if (this.enableLogging) {
                console.log(`DeferredPromiseExecutor[${this.instanceId}] defer: ${id}`);
            }
            if (this.deferredPromises[id]) {
                if (this.enableLogging) {
                    console.warn(`DeferredPromiseExecutor[${this.instanceId}] the deferred promise ${id} already exists!`);
                }
                throw new Error(DeferredPromiseExecutor.ERROR_PROMISE_ALREADY_DEFRRED);
            }
            return new Promise((resolve, reject) => {
                // store the resolve & reject handlers for deferred execution
                const deferredPromise = { resolve, reject };
                this.deferredPromises[id] = deferredPromise;
                // this makes sure the promise is timed out after a while
                deferredPromise.timeoutHandle = setTimeout(() => {
                    if (this.enableLogging) {
                        console.warn(`DeferredPromiseExecutor[${this.instanceId}] the deferred promise timed out: ${id}`);
                    }
                    const deferredPromiseHandlers = this.getDeferredPromiseHandlers(id);
                    // reject it because of the timeout
                    const error = new Error(`the deferred promise timed out after: ${this.timeout} seconds`);
                    error.name = DeferredPromiseExecutor.ERROR_TIMEOUT;
                    error.message = "deferred promise " + id;
                    deferredPromiseHandlers === null || deferredPromiseHandlers === void 0 ? void 0 : deferredPromiseHandlers.reject(error);
                }, this.timeout);
            });
        };
        this.resolve = (id, result) => __awaiter(this, void 0, void 0, function* () {
            if (this.enableLogging) {
                console.log(`DeferredPromiseExecutor[${this.instanceId}] the deferred promise was resolved [✓] ${id}`);
            }
            const deferredPromiseHandlers = this.popDeferredPromise(id);
            return deferredPromiseHandlers === null || deferredPromiseHandlers === void 0 ? void 0 : deferredPromiseHandlers.resolve(result);
        });
        this.reject = (id, reason) => __awaiter(this, void 0, void 0, function* () {
            if (this.enableLogging) {
                console.log(`DeferredPromiseExecutor[${this.instanceId}] the deferred promise was rejected [x] ${id}`);
            }
            const deferredPromiseHandlers = this.popDeferredPromise(id);
            return deferredPromiseHandlers === null || deferredPromiseHandlers === void 0 ? void 0 : deferredPromiseHandlers.reject(reason);
        });
        this.ignore = (id) => {
            if (this.enableLogging) {
                console.log(`DeferredPromiseExecutor[${this.instanceId}] the deferred promise was ignored [x] ${id}`);
            }
            const deferredPromiseHandlers = this.popDeferredPromise(id);
        };
        this.hasHandlers = (id) => {
            const deferredPromiseHandlers = this.getDeferredPromiseHandlers(id);
            return deferredPromiseHandlers !== undefined;
        };
        this.removeAllHandlers = () => {
            this.deferredPromises = [];
        };
        this.getDeferredPromiseHandlers = (id) => {
            return this.deferredPromises[id];
        };
        if (enableLogging) {
            console.log(`DeferredPromiseExecutor[${this.instanceId}] initialized with timeout: ${timeout}`);
        }
        this.timeout = timeout;
        this.enableLogging = enableLogging;
    }
    //endregion
    //region Private Methods
    popDeferredPromise(id) {
        const deferredPromiseHandlers = this.getDeferredPromiseHandlers(id);
        if (!deferredPromiseHandlers) {
            return;
        }
        // abort the timeout
        if (deferredPromiseHandlers.timeoutHandle) {
            clearTimeout(deferredPromiseHandlers.timeoutHandle);
            deferredPromiseHandlers.timeoutHandle = undefined;
        }
        // remove from the list of promises
        delete this.deferredPromises[id];
        return deferredPromiseHandlers;
    }
}
exports.default = DeferredPromiseExecutor;
//endregion
//region Static Fields
DeferredPromiseExecutor.ERROR_TIMEOUT = "deferred_promise_executor_error_timeout";
DeferredPromiseExecutor.ERROR_PROMISE_ALREADY_DEFRRED = "deferred_promise_executor_error_promise_already_deferred";
//endregion
//region Public Methods
DeferredPromiseExecutor.generateRandomId = () => {
    // tslint:disable-next-line: no-bitwise
    return ((Math.random() * 1e6) | 0);
};
//# sourceMappingURL=DeferredPromiseExecutor.js.map